<template>
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <Alert v-if="show_error_form" :dismissable="true" @close="show_error_form = false"
                   class="bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50">
                Correggi gli errori di inserimento
            </Alert>
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                </div>
            </div>
            <h3 class="text-3xl font-bold mb-3">Nuovo Cliente</h3>
            <Alert v-if="permission_denied" :dismissable="true" @close="permission_denied = false"
                   class="bg-next-orange mb-5 sticky top-0 z-50">Non hai i permessi sufficienti per poter
                creare un contatto
            </Alert>
            <div class="pb-6">
                <Field field_name="Denominazione" :required="true"
                       :errors="getErrors('anagrafica_denominazione_id')">
                    <VueMultiselect
                        v-model="anagraficheAutocomplete.selection"
                        :options="anagraficheAutocomplete.options"
                        :taggable="true"
                        :clear-on-select="false"
                        :preserveSearch="true"
                        @tag="(value)=>anagraficheAutocomplete.add({id:-1, denominazione:value})"
                        placeholder="Denominazione"
                        tagPlaceholder="Crea nuova denominazione"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="denominazione"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="anagraficheAutocompleteSarch">
                        <template v-slot:option="{option}">

                            <div class="flex flex-col text-sm p-3"
                                 :class="getDenominazioneOptionColor(option)">
                                <template v-if="option.isTag">
                                    <span>Aggiungi denominazione: <span
                                        class="font-bold">{{ option.label }}</span></span>
                                </template>
                                <template v-else>
                                    <div class="flex items-center justify-between">
                                        <div class="flex flex-col">

                                        <span>Denominazione: <span
                                            class="font-bold">{{ option.denominazione }}</span></span>
                                            <span>Ragione sociale: <span
                                                class="font-bold">{{ option.ragione_sociale }}</span></span>
                                            <span>Partita IVA: <span
                                                class="font-bold">{{ option.partita_iva }}</span></span>
                                            <span>CF: <span class="font-bold">{{ option.codice_fiscale }}</span></span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>


            <AnagraficaAzienda
                :errors="errors"
                @update:azienda_id="onUpdateAziendaId"
                :disable_dati_azienda="disable_dati_azienda"
                :disable_autocomplete_azienda="disable_autocomplete_azienda"
                v-model:azienda_id="azienda_model.azienda_id"
                v-model:place_id="azienda_model.a_place_id"
                v-model:lat="azienda_model.a_lat"
                v-model:lng="azienda_model.a_lng"
                v-model:estera="azienda_model.estera"
                v-model:tipo="azienda_model.tipo"
                v-model:partita_iva="azienda_model.partita_iva"
                v-model:codice_fiscale="azienda_model.codice_fiscale"
                v-model:ragione_sociale="azienda_model.ragione_sociale"
                v-model:sede_legale_nazione_id="azienda_model.sede_legale_nazione_id"
                v-model:sede_legale_provincia_id="azienda_model.sede_legale_provincia_id"
                v-model:sede_legale_comune_id="azienda_model.sede_legale_comune_id"
                v-model:sede_legale_regione_estero="azienda_model.sede_legale_regione_estero"
                v-model:sede_legale_citta_estero="azienda_model.sede_legale_citta_estero"
                v-model:sede_legale_via="azienda_model.sede_legale_via"
                v-model:sede_legale_cap="azienda_model.sede_legale_cap"
                v-model:sede_legale_numero="azienda_model.sede_legale_numero"
            >
            </AnagraficaAzienda>

            <AnagraficaDenominazione
                :errors="errors"
                :disabled="disable_dati_denominazione"
                v-model:anagrafica_denominazione_id="azienda_model.anagrafica_denominazione_id"
                v-model:denominazione="azienda_model.denominazione"
                v-model:sito="azienda_model.sito"
                v-model:gruppo_di_appartenenza="azienda_model.gruppo_di_appartenenza"
                v-model:place_id="azienda_model.place_id"
                v-model:lat="azienda_model.lat"
                v-model:lng="azienda_model.lng"
                v-model:sede_operativa_via="azienda_model.sede_operativa_via"
                v-model:sede_operativa_numero="azienda_model.sede_operativa_numero"
                v-model:sede_operativa_nazione_id="azienda_model.sede_operativa_nazione_id"
                v-model:sede_operativa_cap="azienda_model.sede_operativa_cap"
                v-model:sede_operativa_regione_estero="azienda_model.sede_operativa_regione_estero"
                v-model:sede_operativa_citta_estero="azienda_model.sede_operativa_citta_estero"
                v-model:sede_operativa_provincia_id="azienda_model.sede_operativa_provincia_id"
                v-model:sede_operativa_comune_id="azienda_model.sede_operativa_comune_id"
                v-model:email="azienda_model.email"
                v-model:pec="azienda_model.pec"
                v-model:telefono_1="azienda_model.telefono_1"
                v-model:telefono_2="azienda_model.telefono_2"
                v-model:fax="azienda_model.fax"
            >
                <div class="flex items-end justify-center mb-3">
                    <NextButton @click="copiaDaSedeLegale" class="w-50 p-3">Copia dati dalla sede legale</NextButton>
                </div>
            </AnagraficaDenominazione>

            <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5">
                <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Assegnazioni
                    cliente</h6>
                <div class="flex flex-col mb-3">
                    <Field field_name="Settore commerciale" :required="true" v-model="settoriSelections"
                           :errors="getErrors('settori')">
                        <VueMultiselect :searchable="true"
                                        trackBy="descrizione"
                                        label="descrizione"
                                        v-model="settoriSelections"
                                        :options="settoriOptions"
                                        :multiple="true" :taggable="false"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        class="next-vue-multiselect"
                                        placeholder="Settore commerciale"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        tagPlaceholder="Aggiungi settore">
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.descrizione }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3">
                    <Field field_name="Lavoro new business" :errors="getErrors('lavoro_new_business')">
                        <VueMultiselect v-model="buAutocomplete.selection" :options="buAutocomplete.options"
                                        :multiple="true"
                                        :disabled="!hasPermission('set lavoro_new_business')"
                                        @search-change="buAutocomplete.search"
                                        :close-on-select="false" :clear-on-select="false"
                                        placeholder="Accounts"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        tagPlaceholder="Aggiungi account"
                                        class="next-vue-multiselect"
                                        track-by="id" label="name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">{{
                                            option.label || '&nbsp;'
                                        }}</span>
                                    <span>{{ option.nome }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.label }}</span>
                                <span class="ml-2">{{ option.nome }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col pb-3">
                    <Field field_name="Responsabile New Business" :errors="getErrors('responsabile_id')">
                        <VueMultiselect @search-change="responsabileAutocomplete.search"
                                        :loading="responsabileAutocomplete.isLoading"
                                        :options="responsabileAutocomplete.options"
                                        v-model="responsabileAutocomplete.selection"
                                        track-by="id" label="name"
                                        placeholder="Responsabile new business"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect-single">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                            <span>
                                <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">{{
                                        option.bu_label
                                    }}</span>
                                <span class="mr-2">{{ option.name }}</span>
                            </span>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3 ">
                    <Field field_name="Presentazione" :errors="getErrors('presentazioni')">
                        <VueMultiselect v-model="presentazioneAutocomplete.selection"
                                        :options="presentazioneAutocomplete.options"
                                        :multiple="true"
                                        @search-change="presentazioneAutocomplete.search"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        placeholder="Presentazione"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect"
                                        track-by="id"
                                        label="name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.bu_label || '&nbsp;' }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3">
                    <Field field_name="Account" :errors="getErrors('accounts')">
                        <VueMultiselect v-model="accountAutocomplete.selection"
                                        :options="accountAutocomplete.options"
                                        :multiple="true"
                                        @search-change="accountAutocomplete.search"
                                        :close-on-select="false" :clear-on-select="false"
                                        placeholder="Accounts"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        tagPlaceholder="Aggiungi account"
                                        class="next-vue-multiselect"
                                        track-by="id" label="name">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">{{
                                            option.bu_label || '&nbsp;'
                                        }}</span>
                                    <span>{{ option.name }}</span>
                                </MultiselectOption>
                            </template>

                            <template v-slot:option="{option}">
                            <span>
                                <span class="text-xs border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col pb-3">
                    <Field field_name="Origine lead" :required="false"
                           :errors="getErrors('origine_lead')">
                        <VueMultiselect v-model="origine_lead_model"
                                        :options="origine_lead_options"
                                        :close-on-select="true" :clear-on-select="false"
                                        placeholder="Origine lead"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect-single"
                                        track-by="id" label="text">
                        </VueMultiselect>
                    </Field>
                </div>


                <!--albo-->
                <div class="col-start-1 flex flex-col pb-3">
                    <Field field_name="Necessità iscrizione albo fornitori" :errors="getErrors('albo_fornitori')">
                        <VueMultiselect v-model="albo_fornitori_model" :options="albo_fornitori_options"
                                        :multiple="false"
                                        :allowEmpty="false"
                                        :close-on-select="true" :clear-on-select="false"
                                        placeholder="Albo fornitori"
                                        class="next-vue-multiselect-single"
                                        track-by="id" label="text">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col pb-3"
                     :class="{'hidden': azienda_model.albo_fornitori!=='Si'}">
                    <Field field_name="Data limite iscrizione albo fornitori"
                           :errors="getErrors('data_albo_fornitori')">
                        <input :disabled="azienda_model.albo_fornitori !== 'Si'"
                               v-model="azienda_model.data_albo_fornitori" type="date"
                               class="flex-grow p-7px bg-next-gray-md-dark group-hover:bg-white">
                    </Field>
                </div>
                <!--                <div class="flex flex-col pb-3"
                                     :class="{'hidden': azienda_model.albo_fornitori!=='Si'}">
                                    <Field field_name="Referente" :errors="getErrors('referente_id')">
                                        <VueMultiselect v-model="referenteAutocomplete.selection"
                                                        :options="referenteAutocomplete.options"
                                                        @search-change="referenteAutocomplete.search"
                                                        :close-on-select="true"
                                                        :clear-on-select="true"
                                                        placeholder="Referente"
                                                        deselectLabel="Deseleziona"
                                                        selectedLabel="Selezionato"
                                                        selectLabel="Seleziona"
                                                        class="next-vue-multiselect-single"
                                                        track-by="id"
                                                        label="full_name">
                                            <template v-slot:noResult>Nessun elemento trovato.</template>
                                        </VueMultiselect>
                                    </Field>
                                </div>-->
                <div class="flex flex-col pb-3 col-span-3"
                     :class="{'hidden': azienda_model.albo_fornitori!=='Si'}">
                    <Field field_name="Link portale di iscrizione"
                           :errors="getErrors('link_portale')">
                        <input :disabled="azienda_model.albo_fornitori !== 'Si'"
                               v-model="azienda_model.link_portale" type="url"
                               class="p-2 bg-next-gray-md-dark hover:bg-white w-full">
                    </Field>
                </div>
            </div>


            <div class="flex justify-end mt-3">
                <NextButton variant="outline-secondary" component="router-link"
                            :to="{name:'Dashboard'}"
                            class="w-48 flex-shrink py-2 px-4">
                    Chiudi
                </NextButton>
                <NextButton variant="primary"
                            @click="save"
                            :disabled="saving"
                            class="w-48 flex-shrink ml-3 py-2 px-4">
                    Salva
                </NextButton>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import ProgettoAttivoCard from "@/components/ProgettoAttivoCard.vue";
import {Paths} from "@/types";
import {nuovo_cliente} from "@/BreadcrumbsPath";
import Autocomplete from "@/setup/Autocomplete";
import settoriManager from "../api/Settori";
import userManager from "../api/Users";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import aziendeManager from "../api/Aziende";
import Alert from '@/components/Alert.vue';
import businessUnitsManager from "../api/BusinessUnits";
import {mapGetters} from 'vuex';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import clientiManager from "../api/Clienti";
import {ProvinciaComune} from "@/setup/ProvinciaComuneAutocomplete";
import anagraficheManager from "../api/Denominazioni";
import Checkbox from "@/components/Checkbox.vue";
import Select from "@/components/Select.vue";
import MapViewer from "@/components/Address/MapViewer.vue";
import AnagraficaAzienda from "@/views/Anagrafica/AnagraficaAzienda.vue";
import AnagraficaDenominazione from "@/views/Anagrafica/AnagraficaDenominazione.vue";

@Options({
    name: 'NuovoCliente',
    components: {
        AnagraficaDenominazione,
        AnagraficaAzienda,
        MapViewer,
        Select,
        Checkbox,
        NextButton,
        Breadcrumbs,
        ProgettoAttivoCard,
        Topbar,
        MultiselectOption,
        Field,
        Alert
    },
    computed: {
        ...mapGetters([
            'isNewBusiness',
            'hasPermission'
        ])
    }
})
export default class NuovoCliente extends Vue {
    aziendaAutocomplete: any = setup(() => Autocomplete(aziendeManager))
    anagraficheAutocomplete: any = setup(() => Autocomplete(anagraficheManager))
    responsabileAutocomplete: any = setup(() => Autocomplete(userManager))
    presentazioneAutocomplete: any = setup(() => Autocomplete(userManager, true))
    accountAutocomplete: any = setup(() => Autocomplete(userManager, true))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, true, {crm: 1}))

    settoriOptions = []
    settoriSelections = []

    saving = false
    permission_denied = false

    albo_fornitori_options = [
        {id: 'No', text: 'No'},
        {id: 'Si', text: 'Sì'},
        {id: 'Ns', text: 'Non serve'}
    ]

    albo_fornitori_model = {id: 'No', text: 'No'}

    origine_lead_options = [
        {id: 0, text: 'referral'},
        {id: 1, text: 'contattaci/sito'},
        {id: 2, text: 'fiere/eventi'},
    ]
    origine_lead_model: any = null

    azienda_model: any = {
        estera: false,
        tipo: -1,
        denominazione: null,
        anagrafica_denominazione_id: null,
        azienda_id: null,
        partita_iva: null,
        ragione_sociale: null,
        codice_fiscale: null,
        gruppo_di_appartenenza: null,
        data_anniversario: null,
        sito: null,
        settori: [],
        sede_legale_via: null,
        sede_legale_numero: null,
        sede_legale_cap: null,
        sede_legale_comune_id: null,
        sede_legale_provincia_id: null,
        sede_legale_nazione_id: null,
        sede_legale_regione_estero: null,
        sede_legale_citta_estero: null,
        sede_operativa_via: null,
        sede_operativa_numero: null,
        sede_operativa_cap: null,
        sede_operativa_comune_id: null,
        sede_operativa_provincia_id: null,
        sede_operativa_nazione_id: null,
        sede_operativa_regione_estero: null,
        sede_operativa_citta_estero: null,

        fax: null,
        telefono_2: null,
        telefono_1: null,
        pec: null,

        lat: null,
        lng: null,
        place_id: null,
        a_lat: null,
        a_lng: null,
        a_place_id: null,

        responsabile_id: null,
        accounts: [],
        presentazioni: [],
        note: null,
        note_di_presentazione: null,
        albo_fornitori: 'No',
        data_albo_fornitori: null,
        link_portale: null,
        referente_id: null,
        email: null,
        approvata: null,
        lavori_new_business_ids: [],
        origine_lead: null,
        non_interessato_ids: []
    }

    disable_dati_azienda = false
    disable_autocomplete_azienda = false
    disable_dati_denominazione = false

    show_error_form = false

    errors = {}

    getDenominazioneOptionColor(option: any) {
        //se l'anagrafica ha già il cliente
        if (option.cliente_id) {
            return 'bg-green-500 bg-opacity-30'
        } else {
            //se esiste l'anagrafica denominazione ma non il cliente
            if (option.id) {
                return 'bg-red-300 bg-opacity-30'
            }
        }
    }

    copiaDaSedeLegale() {
        this.azienda_model.place_id = this.azienda_model.a_place_id
        this.azienda_model.lat = this.azienda_model.a_lat
        this.azienda_model.lng = this.azienda_model.a_lng
        this.azienda_model.sede_operativa_via = this.azienda_model.sede_legale_via
        this.azienda_model.sede_operativa_numero = this.azienda_model.sede_legale_numero
        this.azienda_model.sede_operativa_cap = this.azienda_model.sede_legale_cap
        this.azienda_model.sede_operativa_comune_id = this.azienda_model.sede_legale_comune_id
        this.azienda_model.sede_operativa_provincia_id = this.azienda_model.sede_legale_provincia_id
        this.azienda_model.sede_operativa_nazione_id = this.azienda_model.sede_legale_nazione_id
        this.azienda_model.sede_operativa_regione_estero = this.azienda_model.sede_legale_regione_estero
        this.azienda_model.sede_operativa_citta_estero = this.azienda_model.sede_legale_citta_estero
    }

    anagraficheAutocompleteSarch($event: any) {
        this.anagraficheAutocomplete.search($event).then(() => {
            this.anagraficheAutocomplete.options.map((e: any) => {
                if (e.cliente_id) {
                    e['$isDisabled'] = true
                }
            })
        })
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    @Watch('aziendaAutocomplete.options')
    addOption(){
        if(this.aziendaAutocomplete.searchValue === '') return
        this.aziendaAutocomplete.options.unshift({
            id:-1,
            label: this.aziendaAutocomplete.searchValue,
            isTag: true
        })
    }

    @Watch('settoriSelections', {deep: true})
    settori(new_value: any, old: any) {
        this.azienda_model.settori = new_value.map((e: any) => e.descrizione)
    }

    @Watch('buAutocomplete.selection', {deep: true})
    lavoriNB(new_value: any, old: any) {
        this.azienda_model.lavori_new_business_ids = new_value.map((e: any) => e.id)
    }

    @Watch('tipo_model')
    tipo(new_value: any, old: any) {
        this.azienda_model.tipo = new_value.id
    }

    @Watch('responsabileAutocomplete.selection')
    responsabile(new_value: any, old: any) {
        this.azienda_model.responsabile_id = new_value?.id || new_value
    }

    @Watch('presentazioneAutocomplete.selection')
    presantazioni(new_value: any, old: any) {
        this.azienda_model.presentazioni = new_value.map((e: any) => e.id)
    }

    @Watch('accountAutocomplete.selection')
    account(new_value: any, old: any) {
        this.azienda_model.accounts = new_value.map((e: any) => e.id)
    }

    onUpdateAziendaId($event: any) {
        // se event non è null o -1 allora disabilito i dati azienda
        this.disable_dati_azienda = !!($event && $event > 0);
    }

    @Watch('anagraficheAutocomplete.selection')
    anagrafica(new_value: any, old: any) {
        if (new_value) {
            if (new_value.id > 0) {
                this.disable_autocomplete_azienda = true
                this.disable_dati_denominazione = true
                this.azienda_model.azienda_id = new_value?.azienda_id ?? null
                this.azienda_model.anagrafica_denominazione_id = new_value.id
            } else {
                this.disable_autocomplete_azienda = false
                this.disable_dati_denominazione = false
                this.azienda_model.anagrafica_denominazione_id = -1
                this.azienda_model.denominazione = new_value?.denominazione

            }
        } else {
            this.disable_autocomplete_azienda = false
            this.disable_dati_denominazione = false
            this.azienda_model.anagrafica_denominazione_id = null
        }
    }

    @Watch('origine_lead_model')
    lead(new_value: any, old: any) {
        this.azienda_model.origine_lead = new_value ? new_value.id : null
    }

    @Watch('albo_fornitori_model')
    alboFornitori(new_value: any, old: any) {
        this.azienda_model.albo_fornitori = new_value.id
    }

    save() {
        this.saving = true
        this.permission_denied = false
        clientiManager.clienteCreate(this.azienda_model).then((res: any) => {
            //@ts-ignore
            this.$router.replace({name: 'DettaglioAzienda', params: {id: res.data.id}})
            this.show_error_form = false
        }).catch((res: any) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
                this.show_error_form = true
            }
            if (res.response.status == 403) {
                this.permission_denied = true
            }
        }).finally(() => {
            this.saving = false
        })
    }

    get getBreadcrumbsPath(): Paths[] {
        return nuovo_cliente
    }

    created() {
        settoriManager.settori().then((response) => {
                this.settoriOptions = response.data
            }
        )
        this.buAutocomplete.search('', 0)
        this.responsabileAutocomplete.search('', 0)
        this.accountAutocomplete.search('', 0)
        this.presentazioneAutocomplete.search('', 0)
        this.aziendaAutocomplete.search('', 0)

        this.anagraficheAutocompleteSarch('')
    }
}
</script>


<style lang="scss" scoped>

</style>
